module.exports = __webpack_public_path__ + "static/media/jaiHanuman.0d62b896.jpeg";